/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Deleteattempttitle2Inputs */

const zh_learn_deleteattempttitle2 = /** @type {(inputs: Learn_Deleteattempttitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除作答记录`)
};

const en_learn_deleteattempttitle2 = /** @type {(inputs: Learn_Deleteattempttitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Attempt`)
};

const es_learn_deleteattempttitle2 = /** @type {(inputs: Learn_Deleteattempttitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar intento`)
};

/**
* | output |
* | --- |
* | "Delete Attempt" |
*
* @param {Learn_Deleteattempttitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_deleteattempttitle2 = /** @type {((inputs?: Learn_Deleteattempttitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Deleteattempttitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_deleteattempttitle2(inputs)
	if (locale === "en") return en_learn_deleteattempttitle2(inputs)
	return es_learn_deleteattempttitle2(inputs)
});
export { learn_deleteattempttitle2 as "learn_deleteAttemptTitle" }